import { useQuery } from '@apollo/client'
import { ultimosModificadosQueryGqlExpanded } from '../data/ultimo-modificados-query'
import { UltimosModificadosQueryGqlExtendedQuery } from '../../../core/types/graphql'

export const useLastCreatedBox = () => {
  const { data: { ultimosModificados } = {}, loading } =
    useQuery<UltimosModificadosQueryGqlExtendedQuery>(
      ultimosModificadosQueryGqlExpanded
    )

  return { ultimosModificados, loading }
}
